export default __webpack_public_path__ + "static/media/tags.736c7c87.svg";